export default {
	passwordConfirmation: {
		// Security Section
		securityVerification: 'Security Verification',
		enterPassword: 'Enter your password',
		invalidPassword: 'Invalid password. Please try again.',
		verificationError: 'Unable to verify password. Please try again later.',
		disclaimerConfirmation: 'I have read and understood the implications of this action',
		// General
		whatHappens: 'What happens next?',
		disclaimer: 'Important Note',
		hint: 'Tip',
	},
}
